module.exports = __webpack_public_path__ + "static/img/2016.04f4643.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2016.png
// module id = g4G/
// module chunks = 1